/*
Sohel 12/21/2022 3075154998 integrated Basic Info API.
Sohel 12/22/2022 3075154998 Integrated Record Format Fields API
Sohel 12/22/2022 3075154998 selected processor fields API integration
Sohel 12/30/2022 3075154998 Add processor Group API integration
Sohel 01/03/2023 2701323910 payload Changes
Sohel 09/01/2023 2701323910 removed duplicate key
Dilip 01/11/2023 2701323910 Integrated system notes api
Dilip 01/11/2023 2701323910 integrated download configuration api
dilip 01/12/2023 2701323910 Added status values.
Sohel 01/12/2023 2701323910 fixed filterCriteria page break issue
Ashraf 01/13/2023 2701323910 fixed loader issue
Sai maheshwar 01/13/2023 2698925801, 2699294669 fixed double save button issue
Sohel 01/18/2023 3075154998 fixed reset Issue
Sohel 01/23/2023 2698964415 Added Audit Fields table
Sohel 01/23/2023 2698964415 validation API payload changes
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Dilip 02/24/2023 2701323910 implemented preview file functionality in download configuration
Dilip 03/01/2023 2698964415 integrated preprocessor duplicate check validation api
Sohel 02/03/2023 2701335619 header line changes
Sohel 03/10/2023 2701335619 Added Error Record in Action
Sohel 03/15/2023 2701335619 hide Duplicate Criteria Based on condition
Akhila 04/06/2023 2701335619 Added dropdowndata api on field actionss
Akhila 04/25/2023 2701335619  Added usage and override functionality in transformation group
Sohel 02/05/2023 2701335619 Fixed PageBreak Issue
Sohel 06/02/2023 2701335619 Added Lookup DropDown
Sohel 06/03/2023 2701334326 Added Amount Format Field
Ravi 06/23/2023 2701335619 fixed submit issue
Ravi 07/11/2023 2698964415 added type in get api
*/
import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {fetchDownloadSuccess} from '../PreviewFileData';
import {
  AMOUNT_FORMAT,
  DATE_FORMAT,
  TEXT_FORMAT,
  TIME_FORMAT,
  AMOUNT_TYPE,
  PHONE_FORMAT,
  SSN,
} from '../../../constants/Lookup';
import {submissionEnd} from '../CommonActions/commonActions';

const initialState = {
  isBasicInfoLoading: false,
  basicInfoSuccessMsg: null,
  basicInfoErrorMsg: null,
  basicInfoStatus: null,
  basicInfoData: {},
  recordCode: '',
  fixedLength: '',
  isRecordFieldsLoading: false,
  recordFieldsSuccessMsg: null,
  recordFieldsErrorMsg: null,
  recordFieldsStatus: null,
  recordFormatFieldsData: {},
  masterRecordFormatFieldsData: [],
  isProcessorLoading: false,
  processorSuccessMsg: null,
  processorErrorMsg: null,
  processorStatus: null,
  selectedProcessorFields: {},
  allRecordCode: [],
  isPreprocessorLoading: false,
  preProcessorSuccessMsg: null,
  preProcessorErrorMsg: null,
  preProcessorStatus: null,
  prepProcessorGroupData: {},
  isAddProcessorLoading: false,
  addProcessorSuccessMsg: null,
  addProcessorErrorMsg: null,
  addProcessorStatus: null,
  addProcessorGroupData: {},
  addFilterCriteriaStatus: null,
  filterCriteriaSuccessMsg: null,
  isFilterCriteriaLoading: false,
  filterCriteriaErrorMsg: null,
  filterCriteriaData: {},
  preprocessorGroupNames: null,
  preprocessorNames: null,
  category: {},
  dmFormatsData: null,
  addSystemNotesStatus: null,
  isDraftRecord: '',
  lastStep: 0,
  auditFieldsData: [],
  dataManagerRecordUsage: {},
  downloadSuccessMessage: null,
  configurationUrl: '',
  dockey: '',
  headerLines: null,
  errorRecordDropdownData: [],
  isAccountNumbers: '',
  translationData: [],
  statusFieldsData: [],
  exportErrorRecordData: [],
  warningError: null,
  dataTranformationData: {},
  preProcessorUsageData: [],
  addUsageData: {},
  userMetrix: '',
  statusCode: null,
  selectedFields: [],
};

const dataManagerRecord = createSlice({
  name: 'ediFilterExport',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isBasicInfoLoading = true;
      state.basicInfoErrorMsg = null;
    },
    fetchError: (state, action) => {
      state.basicInfoErrorMsg = action.payload;
      state.isBasicInfoLoading = false;
    },
    fetchPreProcessor: (state, action) => {
      state.isPreprocessorLoading = true;
      state.preProcessorErrorMsg = null;
    },
    fetchPreProcessorError: (state, action) => {
      state.isPreprocessorLoading = false;
      state.preProcessorErrorMsg = action.payload;
    },
    fetchFilterCriteria: (state, action) => {
      state.isFilterCriteriaLoading = true;
      state.filterCriteriaErrorMsg = null;
    },
    fetchFilterCriteriaError: (state, action) => {
      state.isFilterCriteriaLoading = false;
      state.filterCriteriaErrorMsg = action.payload;
    },
    setConfigUrl: (state, action) => {
      state.isBasicInfoLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isBasicInfoLoading = false;
      state.dockey = action.payload;
    },
    postFilterCriteria: (state, action) => {
      state.addFilterCriteriaStatus = action.payload.status;
      state.filterCriteriaSuccessMsg = action.payload.message;
      state.isFilterCriteriaLoading = false;
      state.filterCriteriaErrorMsg = null;
      state.recordCode = action.payload.response[0]?.code;
      state.isBasicInfoLoading = false;
    },
    getAllRecordCode: (state, action) => {
      state.allRecordCode = action.payload;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    getErrorRecordDropdownData: (state, action) => {
      state.errorRecordDropdownData = action.payload;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    setPreProcessorGroupNames: (state, action) => {
      state.preprocessorGroupNames = action.payload;
      state.isPreprocessorLoading = false;
      state.preProcessorErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    setPreProcessorNames: (state, action) => {
      state.preprocessorNames = action.payload;
      state.isPreprocessorLoading = false;
      state.preProcessorErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    fetchRecordFields: (state) => {
      state.isRecordFieldsLoading = true;
      state.recordFieldsErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    fetchRecordFieldsError: (state, action) => {
      state.recordFieldsErrorMsg = action.payload;
      state.isRecordFieldsLoading = false;
    },
    fetchProcessor: (state, action) => {
      state.isProcessorLoading = true;
      state.processorErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    fetchProcessorError: (state, action) => {
      state.processorErrorMsg = action.payload;
      state.isProcessorLoading = false;
    },
    fetchAddProcessor: (state, action) => {
      state.isAddProcessorLoading = true;
      state.addProcessorErrorMsg = null;
    },
    fetchAddProcessorError: (state, action) => {
      state.isAddProcessorLoading = false;
      state.addProcessorErrorMsg = null;
    },
    postBasicInfoData: (state, action) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = action.payload.status;
      state.basicInfoSuccessMsg = action.payload.message;
      state.isBasicInfoLoading = false;
      state.recordCode = action.payload?.response?.recordCode;
      state.fixedLength = action.payload?.response?.fixedLength;
    },
    postSystemNotesData: (state, action) => {
      state.addSystemNotesStatus = action.payload.status;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = action.payload.message;
    },
    postCopyData: (state, action) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = action.payload.status;
      state.basicInfoSuccessMsg = action.payload.message;
      state.isBasicInfoLoading = false;
      state.recordCode = action.payload?.response?.recordCode;
    },
    postRecordFormatFieldsData: (state, action) => {
      state.isRecordFieldsLoading = false;
      state.recordFieldsSuccessMsg = action.payload?.message;
      state.recordFieldsStatus = action.payload?.status;
      state.recordFieldsErrorMsg = null;
      state.recordCode = action.payload?.response[0]?.recordCode;
      state.isBasicInfoLoading = false;
    },
    postSelectProcessorData: (state, action) => {
      state.isProcessorLoading = false;
      state.processorSuccessMsg = action.payload?.message;
      state.processorStatus = action.payload?.status;
      state.processorErrorMsg = null;
      // state.recordCode = action.payload?.response[0]?.recordCode;
      state.isBasicInfoLoading = false;
    },
    postPreProcessorGroupData: (state, action) => {
      state.isPreprocessorLoading = false;
      state.preProcessorSuccessMsg = action.payload?.message;
      state.preProcessorErrorMsg = null;
      state.preProcessorStatus = action.payload.status;
      state.isBasicInfoLoading = false;
    },
    postAddProcessorGroupData: (state, action) => {
      state.isAddProcessorLoading = false;
      state.addProcessorSuccessMsg = action.payload.message;
      state.addProcessorErrorMsg = null;
      state.addProcessorStatus = action.payload.status;
      state.isBasicInfoLoading = false;
    },
    getDataManagerRecordUsageData: (state, action) => {
      state.dataManagerRecordUsage = action.payload;
      state.basicInfoStatus = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    fetchTranslationData: (state, action) => {
      state.translationData = action.payload;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    getErrorRecordData: (state, action) => {
      state.exportErrorRecordData = action.payload;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    resetExportRecordData: (state, action) => {
      state.exportErrorRecordData = [];
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    resetBasicInfoData: (state) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    resetAddPreProcessorData: (state) => {
      state.isAddProcessorLoading = false;
      state.addProcessorStatus = null;
      state.addProcessorErrorMsg = null;
      state.addProcessorSuccessMsg = null;
    },
    resetRecordFormatFieldsData: (state) => {
      state.recordFieldsErrorMsg = null;
      state.recordFieldsStatus = null;
      state.recordFieldsSuccessMsg = null;
      state.isRecordFieldsLoading = false;
    },
    resetProcessorFieldsData: (state) => {
      state.processorErrorMsg = null;
      state.processorSuccessMsg = null;
      state.processorErrorMsg = null;
      state.isProcessorLoading = false;
    },
    resetPreProcessorGroupData: (state) => {
      state.isPreprocessorLoading = false;
      state.preProcessorSuccessMsg = null;
      state.preProcessorErrorMsg = null;
      state.preProcessorStatus = null;
    },
    getBasicInfoData: (state, action) => {
      state.basicInfoData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getStatusFieldsData: (state, action) => {
      state.statusFieldsData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    setDmFormatData: (state, action) => {
      state.dmFormatsData = action.payload;
      state.isBasicInfoLoading = false;
    },
    setRecordCode: (state, action) => {
      state.recordCode = action.payload;
    },
    setCategoryRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setLastStepRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setFixedLengthRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setDraftStatusRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setHeaderLinesRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setIsAccountNumbersRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    getRecordFormatFieldsData: (state, action) => {
      state.recordFieldsErrorMsg = null;
      state.recordFieldsStatus = null;
      state.recordFieldsSuccessMsg = null;
      state.recordFormatFieldsData = action.payload;
      state.isRecordFieldsLoading = false;
    },
    getMasterRecordFormatFieldsData: (state, action) => {
      state.masterRecordFormatFieldsData = action.payload;
      state.isRecordFieldsLoading = false;
    },
    getSelectedProcessorFieldsData: (state, action) => {
      state.processorErrorMsg = null;
      state.processorStatus = null;
      state.processorSuccessMsg = null;
      state.selectedProcessorFields = action.payload;
      state.isProcessorLoading = false;
    },
    getFieldsData: (state, action) => {
      state.processorErrorMsg = null;
      state.processorStatus = null;
      state.processorSuccessMsg = null;
      state.selectedFields = action.payload;
      state.isProcessorLoading = false;
    },
    getAuditFieldsData: (state, action) => {
      state.auditFieldsData = action.payload;
      state.processorErrorMsg = null;
      state.processorStatus = null;
      state.processorSuccessMsg = null;
      state.isProcessorLoading = false;
    },
    getProcessorGroupData: (state, action) => {
      state.prepProcessorGroupData = action.payload;
      state.isPreprocessorLoading = false;
      state.preProcessorErrorMsg = null;
      state.preProcessorSuccessMsg = null;
    },
    getAddProcessorGroupData: (state, action) => {
      state.addProcessorGroupData = action.payload;
      state.isAddProcessorLoading = false;
      state.addProcessorStatus = null;
      state.addProcessorErrorMsg = null;
      state.addProcessorSuccessMsg = null;
    },

    resetDataManagerRecordData: (state) => {
      state.basicInfoData = {};
      state.recordFormatFieldsData = {};
      state.selectedProcessorFields = {};
      state.prepProcessorGroupData = {};
      state.recordCode = '';
      state.fixedLength = '';
      state.addProcessorGroupData = {};
      state.filterCriteriaData = {};
    },
    resetAddPreprocessorGroupData: (state) => {
      state.isPreprocessorLoading = false;
      state.prepProcessorGroupData = {};
      state.preProcessorSuccessMsg = null;
      state.preProcessorSuccessMsg = null;
    },
    resetFilterCriteria: (state) => {
      state.addFilterCriteriaStatus = null;
      state.filterCriteriaSuccessMsg = null;
      state.isFilterCriteriaLoading = false;
      state.filterCriteriaErrorMsg = null;
      // state.filterCriteriaData = null;
    },
    resetSystemNotesData: (state) => {
      state.isBasicInfoLoading = false;
      state.addSystemNotesStatus = null;
      state.basicInfoSuccessMsg = null;
      state.basicInfoErrorMsg = null;
    },
    setFilterCriteriaData: (state, action) => {
      state.isFilterCriteriaLoading = false;
      state.filterCriteriaErrorMsg = null;
      state.filterCriteriaData = action.payload;
    },
    getPrintDataGroup: (state, action) => {
      state.isBasicInfoLoading = false;
      state.basicInfoSuccessMsg = action.payload.response;
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = null;
    },
    resetBasicInfoRecordData: (state) => {
      state.basicInfoData = {};
    },
    resetDataManagerRecordUsage: (state) => {
      state.isBasicInfoLoading = false;
      state.basicInfoSuccessMsg = null;
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = null;
      state.dataManagerRecordUsage = {};
    },
    fetchWarningError: (state, action) => {
      state.warningError = action?.payload?.data?.error ?
        action.payload.data.error :
        action.payload?.data?.message ?
          action.payload?.data?.message :
          action.payload;
      state.isLoading = false;
    },
    resetErrorMsg: (state, action) => {
      state.warningError = null;
      state.dataTranformationData = {};
    },
    isResetloading: (state) => {
      state.isBasicInfoLoading = false;
    },
    validateDataTransformData: (state, action) => {
      state.dataTranformationData = action.payload?.response;
      state.basicInfoSuccessMsg = action.payload?.message;
      state.isBasicInfoLoading = false;
      state.basicInfoStatus = action.payload.status;
    },
    getPreprocessorGroupUsageData: (state, action) => {
      state.isAddProcessorLoading = false;
      state.addProcessorSuccessMsg = false;
      state.addProcessorErrorMsg = false;
      state.preProcessorUsageData = action.payload;
    },
    resetPreprocessorUsageData: (state, action) => {
      state.preProcessorUsageData = [];
      state.isAddProcessorLoading = false;
      state.addProcessorSuccessMsg = null;
      state.addProcessorErrorMsg = null;
    },
    fetchAddSuccess: (state, action) => {
      state.addProcessorSuccessMsg = action.payload.status ? action.payload.status : '';
      state.isPreprocessorLoading = false;
    },
    getOverrideRuleData: (state, action) => {
      state.isPreprocessorLoading = false;
      state.preProcessorErrorMsg = null;
      state.addProcessorSuccessMsg = action.payload.status;
      state.addUsageData = action.payload.response.placeResponse;
      state.userMetrix = action.payload.response.userMetrix;
    },
  },
});

export const {
  fetchStart,
  fetchError,
  postBasicInfoData,
  resetBasicInfoData,
  getBasicInfoData,
  postRecordFormatFieldsData,
  fetchRecordFieldsError,
  fetchRecordFields,
  resetRecordFormatFieldsData,
  getRecordFormatFieldsData,
  resetDataManagerRecordData,
  postSelectProcessorData,
  fetchProcessor,
  fetchProcessorError,
  resetProcessorFieldsData,
  getSelectedProcessorFieldsData,
  getAllRecordCode,
  postPreProcessorGroupData,
  resetPreProcessorGroupData,
  fetchPreProcessor,
  getProcessorGroupData,
  fetchPreProcessorError,
  resetAddPreprocessorGroupData,
  postAddProcessorGroupData,
  fetchAddProcessor,
  fetchAddProcessorError,
  resetAddPreProcessorData,
  getAddProcessorGroupData,
  fetchFilterCriteria,
  postFilterCriteria,
  fetchFilterCriteriaError,
  resetFilterCriteria,
  setFilterCriteriaData,
  setPreProcessorGroupNames,
  setPreProcessorNames,
  setRecordCode,
  setCategoryRedux,
  setFixedLengthRedux,
  postCopyData,
  setDmFormatData,
  postSystemNotesData,
  resetSystemNotesData,
  setDraftStatusRedux,
  getPrintDataGroup,
  getMasterRecordFormatFieldsData,
  resetBasicInfoRecordData,
  setLastStepRedux,
  getAuditFieldsData,
  getDataManagerRecordUsageData,
  resetDataManagerRecordUsage,
  resetDefault,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
  setHeaderLinesRedux,
  getErrorRecordDropdownData,
  setIsAccountNumbersRedux,
  fetchTranslationData,
  getStatusFieldsData,
  getErrorRecordData,
  resetExportRecordData,
  fetchWarningError,
  resetErrorMsg,
  validateDataTransformData,
  isResetloading,
  getPreprocessorGroupUsageData,
  resetPreprocessorUsageData,
  fetchAddSuccess,
  getOverrideRuleData,
  getFieldsData,
} = dataManagerRecord.actions;
export default dataManagerRecord.reducer;
export const postBasicInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`data-manager/record/save/dmrecord/header`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postBasicInfoData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postCopyRecord = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`data-manager/record/copy/dmimportmanagerrecord`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postCopyData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postRecordFormatFields = (details) => {
  return (dispatch) => {
    dispatch(fetchRecordFields());
    httpPost(`data-manager/record/save/dmrecordformat/field`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postRecordFormatFieldsData(data));
        } else {
          dispatch(fetchRecordFieldsError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchRecordFieldsError(error.message));
      });
  };
};

export const postSelectProcessor = (details, moduleType) => {
  const url = moduleType ?
    'record/group/save/dmselect/field' :
    'data-manager/record/save/dmselect/field';
  return (dispatch) => {
    dispatch(fetchProcessor());
    httpPost(url, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postSelectProcessorData(data));
        } else {
          dispatch(fetchProcessorError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchProcessorError(error.message));
      });
  };
};

// export const postPreProcessorGroup1 = (details) => {
//   return (dispatch) => {
//     dispatch(fetchPreProcessor());
//     httpPost(`data-manager/processor/save`, details)
//       .then((data) => {
//         if (data && data.status && data.status === 200) {
//           dispatch(postPreProcessorGroupData(data));
//         } else {
//           dispatch(fetchPreProcessorError(data?.data?.error));
//         }
//       })
//       .catch((error) => {
//         dispatch(fetchPreProcessorError(error.message));
//       });
//   };
// };

export const postPreProcessorGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchPreProcessor());
    httpPost(`data-manager/processor/save`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(getOverrideRuleData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchPreProcessorError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postPreProcessorGroupData(data));
          // dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchPreProcessorError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postAddProcessorGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchAddProcessor());
    httpPost(`data-manager/record/save/dmrecord/addprocessorgroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postAddProcessorGroupData(data));
        } else {
          dispatch(fetchAddProcessorError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchAddProcessorError(error.message));
      });
  };
};
export const postFilterCriteriaData = (details) => {
  return (dispatch) => {
    dispatch(fetchFilterCriteria());
    httpPost(`dmfilter/save/edifilter`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postFilterCriteria(data));
        } else {
          dispatch(fetchFilterCriteriaError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchFilterCriteriaError(error.message));
      });
  };
};

export const fetchBasicInfoData = (type, recordCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/record/get/dmrecord/${type}/${recordCode}`)
      .then((data) => {
        dispatch(setRecordCode(recordCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getBasicInfoData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchExportErrorRecordData = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/record/search/errorrecord/${type}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getErrorRecordData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchTranslationDropdownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/record/find/all/translationcodes`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchTranslationData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchDataManagerRecordUsage = (type, recordCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dm/get/dmrecord/usage/${type}/${recordCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getDataManagerRecordUsageData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const fetchDmFormats = (type, recordCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [
        SSN,
        PHONE_FORMAT,
        TEXT_FORMAT,
        TIME_FORMAT,
        AMOUNT_FORMAT,
        DATE_FORMAT,
        AMOUNT_TYPE,
      ],
    })
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          const formats = data.data || {};
          Object.assign(formats, {
            Date: formats.DATE_FORMAT?.length > 0 ? formats.DATE_FORMAT?.map((el) => el.value) : [],
            Text: formats.TEXT_FORMAT?.length > 0 ? formats.TEXT_FORMAT?.map((el) => el.value) : [],
            Amount:
              formats.AMOUNT_FORMAT?.length > 0 ? formats.AMOUNT_FORMAT?.map((el) => el.value) : [],
            SSN: formats.SSN?.length > 0 ? formats.SSN?.map((el) => el.value) : [],
            Phone:
              formats.PHONE_FORMAT?.length > 0 ? formats.PHONE_FORMAT?.map((el) => el.value) : [],
            Time: formats.TIME_FORMAT?.length > 0 ? formats.TIME_FORMAT?.map((el) => el.value) : [],
          });
          delete formats.DATE_FORMAT;
          delete formats.TEXT_FORMAT,
          delete formats.AMOUNT_FORMAT,
          delete formats.TIME_FORMAT,
          delete formats.PHONE_FORMAT,
          dispatch(setDmFormatData(formats));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchRecordFormatFieldsData = (type, recordCode) => {
  return (dispatch) => {
    dispatch(fetchRecordFields());
    httpGet(`data-manager/record/get/dmrecordfield/${type}/${recordCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchRecordFieldsError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getRecordFormatFieldsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchRecordFieldsError(error.message));
      });
  };
};
export const fetchMasterRecordFormatFieldsData = (type, recordCode) => {
  return (dispatch) => {
    dispatch(fetchRecordFields());
    httpGet(`data-manager/record/get/dmrecordfield/${type}/${recordCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchRecordFieldsError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getMasterRecordFormatFieldsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchRecordFieldsError(error.message));
      });
  };
};

export const fetchSelectedProcessorFieldsData = (type, recordCode, managerRecordGroup) => {
  const url = managerRecordGroup ?
    'record/group/get/dmselect/field' :
    'data-manager/record/get/dmselect/field';
  return (dispatch) => {
    dispatch(fetchProcessor());
    httpGet(`${url}/${type}/${recordCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchProcessorError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getSelectedProcessorFieldsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchProcessorError(error.message));
      });
  };
};
export const fetchFieldsData = (type, recordCode, managerRecordGroup) => {
  const url = managerRecordGroup ?
    'record/group/get/recordgroupfields' :
    'data-manager/record/get/repositorydetails';
  return (dispatch) => {
    dispatch(fetchProcessor());
    httpGet(`${url}/${type}/${recordCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchProcessorError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getFieldsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchProcessorError(error.message));
      });
  };
};
export const fetchPrePreprocessorGroupData = (type, recordCode, groupCode) => {
  return (dispatch) => {
    dispatch(fetchPreProcessor());
    httpGet(`data-manager/processor/get/${type}/${recordCode}/${groupCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchPreProcessorError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getProcessorGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchPreProcessorError(error.message));
      });
  };
};

export const fetchAddProcessorGroup = (type, recordCode) => {
  return (dispatch) => {
    dispatch(fetchAddProcessor());
    httpGet(`data-manager/record/get/addprocessorgroup/${type}/${recordCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchAddProcessorError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getAddProcessorGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchAddProcessorError(error.message));
      });
  };
};

export const fetchFilterCriteriaData = (code, tabType) => {
  return (dispatch) => {
    dispatch(fetchFilterCriteria());
    httpGet(`dmfilter/get/filter/${code}/${tabType}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchFilterCriteriaError(data?.data?.error));
        } else if (data && data.status && data.status === 200) {
          dispatch(setFilterCriteriaData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchFilterCriteriaError(error.message));
      });
  };
};

export const fetchStatusFieldsData = (recordCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/record/get/repositoryandfieldnames/${recordCode}`)
      .then((data) => {
        // dispatch(setRecordCode(recordCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getStatusFieldsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const validateDataTransform = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`data-manager/processor/validate/dmprocessor`, details)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchWarningError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(validateDataTransformData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetBasicInfo = () => {
  return (dispatch) => {
    dispatch(resetBasicInfoData());
  };
};

export const resetRecordFormatFields = () => {
  return (dispatch) => {
    dispatch(resetRecordFormatFieldsData());
  };
};

export const resetDataManagerRecord = () => {
  return (dispatch) => {
    dispatch(resetDataManagerRecordData());
  };
};

export const resetProcessorFields = () => {
  return (dispatch) => {
    dispatch(resetProcessorFieldsData());
  };
};

export const resetPreProcessorGroup = () => {
  return (dispatch) => {
    dispatch(resetPreProcessorGroupData());
  };
};
export const resetAddPreprocessorGroup = () => {
  return (dispatch) => {
    dispatch(resetAddPreprocessorGroupData());
  };
};

export const resetAddPreProcessor = () => {
  return (dispatch) => {
    dispatch(resetAddPreProcessorData());
  };
};
export const resetExportErrorRecordData = () => {
  return (dispatch) => {
    dispatch(resetExportRecordData());
  };
};

export const resetFilterCriteriaData = () => {
  return (dispatch) => {
    dispatch(resetFilterCriteria());
  };
};

export const fetchAllRecordCode = (type) => {
  return (dispatch) => {
    httpGet(`data-manager/record/find/all/recordcodeanddescription/${type}`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllRecordCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchErrorRecordCode = (recordCode) => {
  return (dispatch) => {
    httpGet(`data-manager/record/get/childerrorrecords/${recordCode}`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getErrorRecordDropdownData(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchPreProcessorGroupNames = (moduleType, type) => {
  return (dispatch) => {
    httpGet(`data-manager/processor/find/all/dmprocessorgroupcodes/${moduleType}/${type}`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(setPreProcessorGroupNames(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchPreProcessorNames = (type) => {
  return (dispatch) => {
    httpGet(`data-manager/record/getall/dmprocessor/name/${type}`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(setPreProcessorNames(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postExportSystemNotes = (details, type) => {
  const url =
    type === 'Export' ?
      `data-manager/record/save/exportrecordnotes` :
      `data-manager/record/save/importrecordnotes`;
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(url, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postPrintImportRecordGroup = (data, type) => {
  const url =
    type === 'Export' ?
      'data-manager/record/print/exportmanagerrecord' :
      'data-manager/record/print/importrecord';
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(url, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printImportMasterGroup({dockey: data?.message}, data, type));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetSystemNotes = () => {
  return (dispatch) => {
    dispatch(resetSystemNotesData());
  };
};
export const resetBasicInfoRecord = () => {
  return (dispatch) => {
    dispatch(resetBasicInfoRecordData());
  };
};
export const resetDataManagerRecordUsageData = () => {
  return (dispatch) => {
    dispatch(resetDataManagerRecordUsage());
  };
};
export const printImportMasterGroup = (payload, postdata, type) => {
  const url =
    type === 'Export' ?
      'data-manager/record/generateurlexportmanagerrecordprint' :
      'data-manager/record/generateimportrecordprinturl';
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(url, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(getPrintDataGroup(postdata));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postdata));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const fetchPreprocessorGroupUsage = (code) => {
  return (dispatch) => {
    dispatch(fetchAddProcessor());
    httpGet(`data-manager/processor/usage/${code}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getPreprocessorGroupUsageData(data.response));
        } else {
          dispatch(fetchAddProcessorError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchAddProcessorError(error?.message));
      });
  };
};

export const resetErrorWarningMsg = () => {
  return (dispatch) => {
    dispatch(resetErrorMsg());
  };
};
export const isResetloadingbar = () => {
  return (dispatch) => {
    dispatch(isResetloading());
  };
};
export const resetPreprocessorGroupUsage = () => {
  return (dispatch) => {
    dispatch(resetPreprocessorUsageData());
  };
};
